export default "__VITE_ASSET__Bz$JYJb4__"